// src/analytics/consent.js
export const CONSENT_COOKIE = 'toolip_cookie_consent'; // 'granted' | 'denied'

export function readCookie(name) {
  const m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return m ? decodeURIComponent(m[2]) : null;
}

export function writeCookie(name, value, days = 365) {
  const expires = new Date(Date.now() + days*24*60*60*1000).toUTCString();
  // secure; samesite=lax is a good default for consent cookies
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; samesite=lax`;
}

export function hasDNT() {
  const dnt = navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack;
  return dnt === '1' || dnt === 1;
}

export function consentStatus() {
  if (hasDNT()) return 'denied';
  return readCookie(CONSENT_COOKIE) || 'unset';
}

export function grantConsent() {
  writeCookie(CONSENT_COOKIE, 'granted', 365*5);
}
export function denyConsent() {
  writeCookie(CONSENT_COOKIE, 'denied', 365*5);
}
